import React from "react";
import "./Events.css";
import { Link } from "react-router-dom";
import event1 from "../../../../assets/img/event1.jpg";
import event3 from "../../../../assets/img/event3.jpg";

const Events = () => {
	return (
		<div className='uiowa-events'>
			<div className='left'>
				<h2>EVENTS</h2>
				<Link className='btnUiowa d-flex  gap-3'>
					VIEW ALL
					<i
						className='fa fa-arrow-right'
						style={{ color: "#fff" }}
						aria-hidden='true'
					></i>
				</Link>
			</div>
			<div className='right'>
				<div className='event'>
					<img src={event1} alt='Event' />
					<div>
						<Link>
							<h4>Discover Study Abroad</h4>
						</Link>
						<p>Friday, February 17, 2023 - 11:00 AM </p>
						<p className='d-flex align-items-center gap-2'>
							<i className='fa fa-map-marker' aria-hidden='true'></i>
							<>Online</>
						</p>
					</div>
				</div>
				<div className='event'>
					<img src={event3} alt='Event' />
					<div>
						<Link>
							<h4>Mindfullness for College Students</h4>
						</Link>
						<p>Friday, February 17, 2023 - 11:00 AM </p>
						<p className='d-flex align-items-center gap-2'>
							<i className='fa fa-map-marker' aria-hidden='true'></i>
							<>Online</>
						</p>
					</div>
				</div>
				<div className='event'>
					<img src={event3} alt='Event' />
					<div>
						<Link>
							<h4>Wintertime Tree Tour</h4>
						</Link>
						<p>Friday, February 17, 2023 - 11:00 AM </p>
						<p className='d-flex align-items-center gap-2'>
							<i className='fa fa-map-marker' aria-hidden='true'></i>
							<>Online</>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Events;
